import React, {
    useCallback,
    useContext
} from "react";
import PropTypes from "prop-types";

import ShopsContext from "../../../context/ShopsContext";
import RadioChip from "../../../components/RadioChip";

function getProductTypes(shop) {
    const productTypes = [];
    if(shop.entitlementOrders) {
        productTypes.push({
            value: "physical",
            name: "Koop fysiek",
            icon: "fa-solid fa-apple-whole",
        });
        productTypes.push({
            value: "digital",
            name: "Koop digitaal",
            icon: "fa-solid fa-laptop",
        });
    }
    if(shop.entitlementCourses) {
        productTypes.push({
            value: "course",
            name: "Cursus",
            icon: "fa-solid fa-graduation-cap",
        });
    }
    if(shop.entitlementRentals) {
        productTypes.push({
            value: "rental",
            name: "Huur",
            icon: "fa-solid fa-car-side",
        });
    }
    return productTypes;
}

function ProductTypePicker({ productTypes, setProductTypes, disabled = false }) {
    const {
        currentShop
    } = useContext(ShopsContext);

    const availableProductTypes = getProductTypes(currentShop);

    const toggleProductType = useCallback((value) => {
        if(productTypes.includes(value)) {
            setProductTypes(productTypes.filter((productType) => productType !== value));
            return;
        }
        // Rentals have their own ordering flow and pricing, so they can't be combined with
        // other types.
        if(value === "rental" || productTypes.includes("rental")) {
            setProductTypes([value]);
            return;
        }
        setProductTypes([...productTypes, value]);
    }, [productTypes, setProductTypes]);

    return (
        <React.Fragment>
            <div className="d-md-none">
                { availableProductTypes.map((type) => (
                    <RadioChip
                        key={ type.value }
                        checked={ productTypes.includes(type.value) }
                        onClick={ () => toggleProductType(type.value) }
                        className="mr-2 mt-2"
                        disabled={ disabled }
                    >
                        <i className={ `${type.icon} mr-2` }/>
                        { type.name }
                    </RadioChip>
                ))}
            </div>
            <div className="d-none d-md-block">
                <div className="row">
                    { availableProductTypes.map((type) => (
                        <div
                            className="col-md-6 col-xl-3"
                            key={ type.value }
                        >
                            <div
                                className={"card mt-2" + (disabled ? "" : " pointer-cursor") + (productTypes.includes(type.value) ? " active" : "")}
                                onClick={ () => !disabled && toggleProductType(type.value) }
                            >
                                <div className="card-body">
                                    <div style={{ fontSize: "1.5rem" }}>
                                        <i
                                            className={`${type.icon}`}
                                        />
                                    </div>
                                    <div className="mt-1">
                                        { type.name }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <small className="form-text text-muted mt-2">
                Een product kan meerdere types hebben, bijvoorbeeld een fysiek product dat ook
                toegang geeft tot een cursus. Huur kan niet gecombineerd worden met andere types.
            </small>
        </React.Fragment>
    );
}
ProductTypePicker.propTypes = {
    productTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    setProductTypes: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export default React.memo(ProductTypePicker);
